import React, { useState } from "react";
import "./FullScreenImageViewer.css";

function FullScreenImageViewer({ images, startIndex = 0, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(startIndex);

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  if (!images || images.length === 0) return null;

  return (
    <div className="fullscreen-overlay" onClick={onClose}>
      <button className="close-btn" onClick={onClose}>×</button>

      <button className="nav-arrow left" onClick={(e) => { e.stopPropagation(); prevImage(); }}>‹</button>
      <img
        src={images[currentIndex]}
        alt={`image ${currentIndex + 1}`}
        className="fullscreen-image"
        onClick={(e) => e.stopPropagation()}
      />
      <button className="nav-arrow right" onClick={(e) => { e.stopPropagation(); nextImage(); }}>›</button>
    </div>
  );
}

export default FullScreenImageViewer;
